import { Component, ElementRef, ViewChild, OnInit, NgZone } from '@angular/core';

import { ActionSheet, ActionSheetController, Config, NavController, ToastController, PopoverController } from 'ionic-angular';

import { UserData } from '../../providers/user-data';

import { Http, Headers, RequestOptions } from '@angular/http';
import { CommonData } from '../../providers/common-data';
import { ParkbewilligungenData, PbActions } from './parkbewilligungen-data';
import { AlertController } from 'ionic-angular';
import moment from 'moment';
import { AgGridAngular } from 'ag-grid-angular';
import { AllModules, Module } from '@ag-grid-enterprise/all-modules';
import { DeviceDetectorService, BROWSERS } from 'ngx-device-detector';
import { ParkbewilligungenEditPage } from './parkbewilligungen-edit';
import { PbactionsPage } from './pbactions/pbactions';
import { ModalController } from 'ionic-angular';

import { PbperiodenCreatePage } from './pbperioden-create/pbperioden-create';
import { localeDe } from '../../providers/aggridlocale.de'
import { PbTermination } from './pbtermination/pbtermination';

@Component({
  selector: 'parkbewilligungen-list',
  templateUrl: 'parkbewilligungen-list.html'
})

export class ParkbewilligungenListPage implements OnInit {
  actionSheet: ActionSheet;
  eavailability;
  dBegin:any;
  dEnd:any;
  maxDate;
  minDate;
  command: string;
  rowData:any;
  columnDefs:any;
  viewmode:string;
  gridOptions:any;

  selectedpbgname: string;
  selectedpbg: any;
  selectedpbstatus;
  searchQuery: string;
  searchTimeout;
  actFilterModel;
  actNode;
  @ViewChild('pbGrid') agGrid: AgGridAngular;
  modules: Module[] = AllModules;
  

  constructor( public common: CommonData
              , public actionSheetCtrl: ActionSheetController
              , public navCtrl: NavController
              , public http: Http
              , public config: Config
              , public userData: UserData
              , public pbData: ParkbewilligungenData
              , public alertCtrl: AlertController
              , public toastCtrl: ToastController
              , public popoverCtrl: PopoverController
              , public modalCtrl: ModalController
              , public zone: NgZone
              )
              {
                this.columnDefs = [
                  {
                    headerName: 'Physische Parkkarte', field: 'pbiddisplay' , filter: "agNumberColumnFilter", width:170
                  },
                  {
                    headerName: 'pbid', field: 'pbid' , filter: "agNumberColumnFilter" , hide:true
                  }
                  ,{
                    headerName: 'Id', field: 'pbperioden_id' , filter: "agNumberColumnFilter", resizable: true, width:100
                  }
                  

                  ,{headerName: 'Name', field: 'name', resizable: true}
                  ,{headerName: 'Vorname', field: 'vorname', resizable: true}

                  ,{headerName: 'Aktives Kennzeichen', field: 'kennzeichen', resizable: true}
                  ,{headerName: 'Firma', field: 'organisation', resizable: true}
                  ,{headerName: 'Kategorie', field: 'kategorie_text', resizable: true}
                  ,{headerName: 'Status', field: 'status_text', resizable: true}
                  
                  ,{headerName: 'E-Mail', field: 'email', resizable: true}
                  ,{headerName: "Parkplätze (Gross-/Kleinschr. beachten)", field: "attributes.grundstueckenamen", resizable: true, width:200, filter: 'agTextColumnFilter', filterParams:{
                    filterOptions:['contains', 'notContains'],
                    textFormatter: function(r){
                        if (r==null) return null;

                        return r;
                    },
                    debounceMs:0,
                    caseSensitive:true,
                    suppressAndOrCondition:true
                  }},   
                  ,{headerName: "Zonen (Gross-/Kleinschr. beachten)", field: "attributes.pbzonennamen", resizable: true, width:200, filter: 'agTextColumnFilter', filterParams:{
                    filterOptions:['contains', 'notContains'],
                    textFormatter: function(r){
                        if (r==null) return null;

                        return r;
                    },
                    debounceMs:0,
                    caseSensitive:true,
                    suppressAndOrCondition:true
                  }},                                  
                  ,{headerName: 'Gültig ab', field: 'valid_from',  resizable: true,  filter: "agDateColumnFilter",
                    browserDatePicker:true,
                    filterParams: {
                      filterOptions:['greaterThanOrEqual','lessThanOrEqual'],
                      comparator: function(filterLocalDateAtMidnight, cellValue) {
                        
                          if (cellValue === null) return -1;
                          let cellDate = moment(cellValue).toDate();
                          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                            return 0;
                          }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        }
                    },
                      browserDatePicker: true
                  }
                  }
                  ,{headerName: 'Gültig bis', field: 'valid_to', filter:'agDateColumnFilter', resizable: true,
                    browserDatePicker:true,
                    filterParams: {
                      filterOptions:['greaterThanOrEqual','lessThanOrEqual'],
                      comparator: function(filterLocalDateAtMidnight, cellValue) {
                        
                          if (cellValue === null) return -1;
                          let cellDate = moment(cellValue).toDate();
                          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
                            return 0;
                          }
                        if (cellDate < filterLocalDateAtMidnight) {
                            return -1;
                        }
                        if (cellDate > filterLocalDateAtMidnight) {
                          return 1;
                        }
                    },
                      browserDatePicker: true
                  }
                }
                  ,{headerName: 'Preis', field: 'kategorie_preis', resizable: true, filter: "agNumberColumnFilter"}
                  ,{headerName: 'individueller Preis', field: 'preis_uebersteuert', resizable: true, filter: "agNumberColumnFilter"}
                  ,{headerName: 'Bemerkung', field: 'periodenbeschreibung', resizable: true}
                  
                ];      
                

                this.gridOptions = {               
                  localeTextFunc: (key: string, defaultValue: string) =>  localeDe[key] || defaultValue,      
                  isExternalFilterPresent: this.isExternalFilterPresent.bind(this),
                  doesExternalFilterPass: this.doesExternalFilterPass.bind(this),
                  floatingFilter: true,
                  defaultColDef : {
                    filter:true,
                    sortable: true
                  }
               }                
               
                this.viewmode = "pb"
                //this.loaddata();
  }

  archiviertTextValueGetter = function (params){    
    return this.common.boolToText(params.data.physisch);
  }  

  firstDataRendered(event){
    this.defaultFilter();
  }

  rowDataUpdated(event){
    //console.log("rowDataUpdated");
  }

  ionViewWillEnter() {
    this.loaddata();
  }  

  loaddata(displaytoast = true) {
    if(displaytoast){
      this.common.showMessage('Daten werden geladen/aktualisiert', 2000);
    }
    this.pbData.index().then(res => {      
      if(!this.rowData || this.rowData.lenght==0){
        this.rowData = this.pbData.data;
      }
      else{
        //-- Einzeleinträge aktualisieren ---
        //let rowsSelection = this.agGrid.api.getSelectedRows();
        let selectedNodes = this.agGrid.api.getSelectedNodes();
        //console.log(rowsSelection.length);
        for(let i=0; i<selectedNodes.length; i++){
          let actnode = selectedNodes[i];
          let newData = this.pbData.data.find(x => x.pbperioden_id === actnode.data.pbperioden_id);
          if(newData){
            actnode.setData(newData);
            this.agGrid.api.onFilterChanged();
          }    
        }        
      }      
    });
    this.pbData.loadperiodgroups();
  }    

  toggleLoadoldpb(event){
    this.userData.setLoadoldpb(this.userData.loadoldpb);
    this.rowData.lenght = 0;
    this.loaddata();
  } 

  defaultFilter(){

    //-- pbkat filter ---------------
    if(this.pbData.filterPbKat && this.pbData.filterPbKat != ""){
      var kategorieComponent = this.agGrid.api.getFilterInstance('kategorie_text');  
      var modelKat = {
        type: 'set',
        values: [this.pbData.filterPbKat]
      };
      kategorieComponent.setModel(modelKat);
      this.pbData.filterPbKat = "";
      
    }

    //-- pbzonen filter -------------
    if(this.pbData.filterPbZone && this.pbData.filterPbZone != ""){
      //console.log("this.pbData.filterPbZone");
      var zoneComponent = this.agGrid.api.getFilterInstance('attributes.pbzonennamen');  
      //console.log(zoneComponent.getModel());
  
      //console.log(zoneComponent);
      var modelZone = {filterType: "text", type: "contains", filter: this.pbData.filterPbZone+","}
      zoneComponent.setModel(modelZone);      
      this.pbData.filterPbZone = "";
    }


    var statusFilterComponent = this.agGrid.api.getFilterInstance('status_text');
    //console.log(statusFilterComponent);
    var model = {
        type: 'set',
        values: []
    };

    for(let i = 0; i<this.pbData.pbstatus.length; i++){
      switch (this.pbData.pbstatus[i].name) {
        case "geloescht":
        case "inaktiv":
        case "abgelehnt": 
        break;

        default:
          // Anweisungen werden ausgeführt,
          // falls keine der case-Klauseln mit expression übereinstimmt
          model.values.push(this.pbData.pbstatus[i].name);
      }
      //console.log(this.pbData.pbstatus[i].name);
    }
    statusFilterComponent.setModel(model);
    this.agGrid.api.onFilterChanged();
  }

  test(){
    var zoneComponent = this.agGrid.api.getFilterInstance('attributes.pbzonennamen');  
    console.log(zoneComponent.getModel());

    //console.log(zoneComponent);
    var modelZone = {filterType: "text", type: "contains", filter: "Parkplatzgebiet J"+","}
    zoneComponent.setModel(modelZone);      
    this.agGrid.api.onFilterChanged();

  }

  isExternalFilterPresent() {
      return false;
  }
  
  doesExternalFilterPass(node) {
    return true;
    /*
    if(this.searchQuery == ""){
      return true;
    }
    else{
      let tmp : string = node.data.name;
      // tmp = node.data.name;
      return tmp.indexOf(this.searchQuery) !== -1;

      if(node.data.name){
        return node.data.name.indexOf(this.searchQuery) !== -1;
      }
      
      return true;
    }    
    */
  }
  searchGrid(event){
    //console.log(this.gridOptions.api.getDisplayedRowCount());
    this.gridOptions.api.setQuickFilter(this.searchQuery);
    //this.gridOptions.api.onFilterChanged();

  }
  presentActions(event) {
    let popover = this.popoverCtrl.create(PbactionsPage, {}, {cssClass: 'pbactions-popover'});
    popover.onDidDismiss(data => {
      switch (this.pbData.selectedAction) {
        case PbActions.PrintInvoice:
            this.printinvoices();
            break;
        case PbActions.SendInvoice:
            this.sendinvoices();
            break;
        case PbActions.SendReminder:
              this.sendreminders();
            break;
  
        case PbActions.Replace:
            this.assignNewPb();
            break;
            case PbActions.NewPeriod:
            this.clonePeriods();
            break;
        case PbActions.DeletePeriod:
            this.deletePeriods();
            //console.log("create new period");
            break;
        case PbActions.SoftDeletePeriod:
            this.softDeletePeriods();
            //console.log("create new period");
            break;
        case PbActions.VerlaengerungInfoPeriod:
            this.verlaengerungsinfoPeriods();
            break;
        case PbActions.ExcelExport:
            this.excelExport();
            break;        
        case PbActions.TerminatePb:
            this.terminatePb();
            break;        
        default:
            break;
        }      
    }); 
    popover.present({
      ev: event
    });
  }

  gridDefaultFilter(){
    this.selectedpbstatus = null;
    this.agGrid.api.setFilterModel(null);

    this.defaultFilter();
    //this.agGrid.api.onFilterChanged();
  }  
  gridCopyClipboard(){
    this.agGrid.api.copySelectedRowsToClipboard(true);    
  }

  gridRowDblClicked(event: any){     
    //console.log(event.data);
    this.actNode = event.node;
    this.actFilterModel = this.agGrid.api.getFilterModel(); 
    this.navCtrl.push(ParkbewilligungenEditPage,{ title: 'Parkbewilligung', icon: 'add', viewmode:'edit', pbkunden_id:event.data.pbkunden_id, pbperioden_id:event.data.pbperioden_id });   
}

  ngOnInit() {

  }  
  ngAfterViewInit() {

  }  
  
  getSelectedRows() {
    //console.log("hallo");
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map( node => node.data );
    const selectedDataStringPresentation = selectedData.map( node => node.make + ' ' + node.model).join(', ');
    alert(`Selected nodes: ${selectedDataStringPresentation}`);
}


  clonePeriods(){
    const modal = this.modalCtrl.create(PbperiodenCreatePage);
    this.pbData.createnewperiod = {};
    modal.onDidDismiss(data => {
      
      if(this.pbData.createnewperiod && data){
        //-- Loop selected rows -----
        let selectedpbids = [];
        let rowsSelection = this.agGrid.api.getSelectedRows();
        for(let i=0; i<rowsSelection.length; i++){
          //console.log(rowsSelection[i]);
          selectedpbids.push(rowsSelection[i].pbperioden_id);
        }
        //console.log(this.pbData.createnewperiod);
        this.pbData.cloneperiods(selectedpbids, this.pbData.createnewperiod).then(data => {
          //console.log(data);
          this.loaddata();
          
        });
      }

    });      
    modal.present();
  }
  deletePeriods(){
    let alert = this.alertCtrl.create({
      title: 'Perioden löschen',
      message: 'Wollen Sie die ausgewählten Perioden wirklich löschen?',
      buttons: [
        {
          text: 'Nein',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'Ja',
          handler: () => {
            //-- Loop selected rows -----
            let selectedpbids = [];
            let rowsSelection = this.agGrid.api.getSelectedRows();
            for(let i=0; i<rowsSelection.length; i++){
              //console.log(rowsSelection[i]);
              selectedpbids.push(rowsSelection[i].pbperioden_id);
            }
            //console.log(this.pbData.createnewperiod);
            this.pbData.deleteperiods(selectedpbids).then(data => {
              //console.log(data);
              this.loaddata();
              
            });
          }
        }
      ]
    });
    alert.present();        
  }

  softDeletePeriods(){
    let alert = this.alertCtrl.create({
      title: 'Parkbewilligungen löschen',
      message: 'Wollen Sie die ausgewählten Perioden wirklich löschen?',
      buttons: [
        {
          text: 'Nein',
          role: 'cancel',
          handler: () => {
            //console.log('Cancel clicked');
          }
        },
        {
          text: 'Ja',
          handler: () => {
            //-- Loop selected rows -----
            let selectedpbids = [];
            let rowsSelection = this.agGrid.api.getSelectedRows();
            for(let i=0; i<rowsSelection.length; i++){
              //console.log(rowsSelection[i]);
              selectedpbids.push(rowsSelection[i].pbperioden_id);
            }
            //console.log(this.pbData.createnewperiod);
            this.pbData.softdeleteperiods(selectedpbids).then((res:any) => {
              if(res.success){
                this.common.showMessage(res.message, 8000);
              }
              else{
                this.common.showError("Fehler beim Löschen", 8000);
              }
              //console.log(data);
              this.loaddata();
              
            });
          }
        }
      ]
    });
    alert.present();        

  }  
  
  verlaengerungsinfoPeriods(){
    let alert = this.alertCtrl.create({
      title: 'Verlängerungsinfo versenden',
      message: 'Wollen Sie wirklich den ausgewählten Kunden die Verlängerungs-Info senden?',
      buttons: [
        {
          text: 'Nein',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Ja',
          handler: () => {
            //-- Loop selected rows -----
            let selectedpbids = [];
            let rowsSelection = this.agGrid.api.getSelectedRows();
            for(let i=0; i<rowsSelection.length; i++){
              //console.log(rowsSelection[i]);
              selectedpbids.push(rowsSelection[i].pbperioden_id);
            }
            //console.log(this.pbData.createnewperiod);
            this.pbData.periodenverlaengerungsinfo(selectedpbids).then(data => {
              //console.log("verlängerungsinfo gesendet");
              //console.log(data);
              //this.loaddata();
              
            });
          }
        }
      ]
    });
    alert.present();        

  }

  async excelExport(){
    var params = {
      allColumns: true,
      onlySelected: false,
      fileName: "parkbewilligungen.xlsx",
      sheetName: "Parkbewilligungen",
      exportMode: "xlsx"
    };    
    //console.log("START EXCEL EXPORT");
    //console.log(this.gridOptions);
    this.gridOptions.api.exportDataAsExcel(params);
  }

  async terminatePb(){
    let rowsSelection = this.agGrid.api.getSelectedRows();
    if(rowsSelection.length <= 0){
      let toast = this.toastCtrl.create({
        message: "Es ist keine Parkbewilligung ausgewählt",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });      
      toast.present();   
      return;
    }    


    let popover = this.popoverCtrl.create(PbTermination, {}, {cssClass: 'pbtermination'});
    popover.onDidDismiss(async (data:any) => {

      if(data.enddatum){
        
        const selectedNodes = this.agGrid.api.getSelectedNodes();
        const selectedData = selectedNodes.map( node => node.data );
        let perioden_ids = "";
        let perioden_digital_ids = "";
        let perioden_analog_ids = "";
        for(let i=0; i<selectedData.length; i++){
          if(selectedData[i].kommunikation == "digital"){
            perioden_digital_ids = perioden_digital_ids + selectedData[i].pbperioden_id + ",";
          }
          else{
            perioden_analog_ids = perioden_analog_ids + selectedData[i].pbperioden_id + ",";
          }
          
          perioden_ids = perioden_ids + selectedData[i].pbperioden_id;
          if( (i+1) != selectedData.length){
            perioden_ids = perioden_ids + ",";
          }      
        }
        //-- Letztes Komma entfernen --------
        perioden_digital_ids = perioden_digital_ids.slice(0, -1);
        perioden_analog_ids = perioden_analog_ids.slice(0, -1);

        if(perioden_ids != ""){        
          this.pbData.terminate(perioden_ids, data.enddatum).then((result:any) => {
            if(result.success){
              if(data.notifycustomers){
                //-- Kunden informieren ------     
                
                let tmp_perioden_digital_ids = perioden_digital_ids.split(',').map(Number);           
                let tmp_perioden_analog_ids = perioden_analog_ids.split(',').map(Number);        
                let notify_perioden_digital_ids = "";
                let notify_perioden_analog_ids = "";   

                //-- Checken ob Perioden wirklich terminiert wurden, sonst nicht benachrichtigen -------
                for(let i=0; i<tmp_perioden_digital_ids.length; i++){
                  if(result.data.periods_terminated.includes(tmp_perioden_digital_ids[i])){                  
                    notify_perioden_digital_ids = notify_perioden_digital_ids + tmp_perioden_digital_ids[i] + ",";

                  }
                }
                
                for(let i=0; i<tmp_perioden_analog_ids.length; i++){
                  if(result.data.periods_terminated.includes(tmp_perioden_analog_ids[i])){
                    notify_perioden_analog_ids = notify_perioden_analog_ids + tmp_perioden_analog_ids[i] + ",";
                  }
                }
                //-- Letztes Komma entfernen --------
                if(notify_perioden_digital_ids != ""){
                  notify_perioden_digital_ids = notify_perioden_digital_ids.slice(0, -1);
                }
                if(notify_perioden_analog_ids != ""){
                  notify_perioden_analog_ids = notify_perioden_analog_ids.slice(0, -1);
                }

                if(notify_perioden_digital_ids != ""){
                  this.pbData.sendpbchangenotification(notify_perioden_digital_ids);                        
                }
                if(notify_perioden_analog_ids != ""){
                  this.pbData.printinvoices_no_statechange(notify_perioden_analog_ids);                        
                }
              }


              this.common.showMessage(result.message, 8000);
              this.loaddata(false);
            }
            else{
              this.common.showError(result.message, 8000)
              
            }
          });      
        }
  
        

      }
  
    });
    popover.present({
      ev: event
    });        

    
    //await this.pbData.printinvoices_no_statechange(perioden_ids);


  }

  async assignNewPb(){

    let rowsSelection = this.agGrid.api.getSelectedRows();

    if(rowsSelection.length <= 0){
      let toast = this.toastCtrl.create({
        message: "Es ist keine Parkkarte ausgewählt",
        position: 'top',
        cssClass: 'toast-error',
        duration: 3000
      });
      
      toast.present();   



    }    

    else if(rowsSelection.length > 1){
      let toast = this.toastCtrl.create({
        message: "Bitte nur eine Parkkarte auswählen",
        position: 'top',
        cssClass: 'toast-error',
        duration: 4000
      });
      
      toast.present();   

    }
    else{
      if(rowsSelection[0].physisch == 0){
        this.common.showError('Nur für physische Parkkarten möglich.', 3000);
        return;
      }
      //console.log(rowsSelection);
      let alert = this.alertCtrl.create({
        title: 'Parkkarte ersetzen',
        message: 'Wollen Sie die Parkkarte '+rowsSelection[0].pbid+' ersetzen? Die Parkkarte wird dadurch ungültig!',
        buttons: [
          {
            text: 'Nein',
            role: 'cancel',
            handler: () => {
              //console.log('Cancel clicked');
            }
          },
          {
            text: 'Ja',
            handler: () => {
              this.assignNewPb_handler() ;
            }
          }
        ]
      });
      alert.present();    
    }
    

  }
  
  async assignNewPb_handler(){
      let rowsSelection = this.agGrid.api.getSelectedRows();
      await this.pbData.assignNewPb(rowsSelection[0].pbid);
      if(this.pbData.newpbid && this.pbData.newpbid>0){

        let alert = this.alertCtrl.create({
          title: 'Parkkarte ersetzt',
          message: 'Parkbewilligung '+rowsSelection[0].pbid+' ist durch '+this.pbData.newpbid+' ersetzt worden!',
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                this.loaddata();
                
              }
            }
          ]
        });
        alert.present();                    

      }
      else{        
        let alert = this.alertCtrl.create({
          title: 'Fehler beim Ersetzen',
          message: this.pbData.newpbmessage,
          buttons: [
            {
              text: 'Ok',
              role: 'cancel',
              handler: () => {
                
              }
            }
          ]
        });
        alert.present();            
      }
      console.log('TODO Einsatzplan stornieren');
    
  }
  
  async printinvoices(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map( node => node.data );
    let perioden_ids = "";
    for(let i=0; i<selectedData.length; i++){
      perioden_ids = perioden_ids + selectedData[i].pbperioden_id;
      if( (i+1) != selectedData.length){
        perioden_ids = perioden_ids + ",";
      }      
    }
    //console.log(perioden_ids);
    await this.pbData.printinvoices_no_statechange(perioden_ids);

  }

  async sendinvoices(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map( node => node.data );
    let perioden_ids = "";
    for(let i=0; i<selectedData.length; i++){
      perioden_ids = perioden_ids + selectedData[i].pbperioden_id;
      if( (i+1) != selectedData.length){
        perioden_ids = perioden_ids + ",";
      }      
    }
    //console.log(perioden_ids);
    await this.pbData.sendinvoices(perioden_ids, false);
    this.loaddata();

  }
  async sendreminders(){
    const selectedNodes = this.agGrid.api.getSelectedNodes();
    const selectedData = selectedNodes.map( node => node.data );
    let perioden_ids = "";
    for(let i=0; i<selectedData.length; i++){
      perioden_ids = perioden_ids + selectedData[i].pbperioden_id;
      if( (i+1) != selectedData.length){
        perioden_ids = perioden_ids + ",";
      }      
    }
    //console.log(perioden_ids);
    await this.pbData.sendreminders(perioden_ids, false);
    this.loaddata();

  }

  addParkbewilligung(){
    this.navCtrl.push(ParkbewilligungenEditPage,{ title: 'Parkbewilligung erfassen', icon: 'add', viewmode:'create'});   
  }



  filterItems(ev: any) {
    this.searchGrid(ev);
    /*
    // Reset items back to all of the items
    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {  
      //this.searchQuery = ev.target.value;
      
    }, 1000);  
    */

  }      

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/parkbewilligungen-list.ts